export default {"src":"/_next/static/media/youtube-icon.5c3cdd0b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};